export default __webpack_public_path__ + "assets/63223313df0711d4c7f0eb4f195dd63c.jpg";